import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
const _ = require('lodash');
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import * as defaultRules from 'vee-validate/dist/rules';
import VModal from 'vue-js-modal';
import store from './store/index';
import 'heightline';
import '@babel/polyfill';
import 'url-search-params-polyfill'; // IE11でURLSearchParamsを使用するため追加

Vue.config.productionTip = false;

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// vee-validateでデフォルトで定義されているruleを全てextendする
_.forEach(defaultRules, (rule: any, name: string) => {
  extend(name, rule);
});

Vue.use(VModal);

const metaDescriptionElement: any = document.getElementById(
  'head-meta-description'
);

const metaCanonicalElement: any = document.getElementById(
  'head-meta-canonical'
);

router.afterEach((to: any, from: any) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta && to.meta.description) {
    metaDescriptionElement.content = to.meta.description;
  }
  if (to.meta && to.meta.canonical) {
    metaCanonicalElement.href = to.meta.canonical;
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
